'use strict';

/* eslint no-magic-numbers: off */

const SHG_SPORTS = require('../constants/sports');
const knownSports = require('./knownSports');

const validValues = Object.keys(SHG_SPORTS).map(name => SHG_SPORTS[name]);
const populate = indexes => indexes.map(index => knownSports[index]);

const supportedSports = {
  AMERICAN_FOOTBALL: populate([ 9 ]),
  BASKETBALL: populate([ 6 ]),
  BOXING: populate([ 47 ]),
  CROSS_COUNTRY_SKIING: populate([ 12, 35 ]),
  CYCLING: populate([ 2, 49 ]),
  ELECTRIC_BIKE: populate([ 21, 99, 80 ]),
  EXTREME_SPORTS: populate([ 26, 34 ]),
  GOLF: populate([ 25 ]),
  HANDBIKE: populate([ 64 ]),
  HIKING: populate([ 11, 16, 17, 35 ]),
  HORSE_RIDING: populate([ 27 ]),
  ICE_SKATING: populate([ 33 ]),
  INDOOR_CYCLING: populate([ 58, 67 ]),
  KITESURF: populate([ 44 ]),
  ROCK_CLIMB: populate([ 31, 48 ]),
  ROLLER: populate([ 30 ]),
  ROWING: populate([ 15 ]),
  RUNNING: populate([ 1 ]),
  SAIL_AND_BOARD: populate([ 19, 32, 37, 39, 40 ]),
  SKIING: populate([ 13, 14 ]),
  SOCCER: populate([ 7 ]),
  SURF: populate([ 38 ]),
  SWIMMING: populate([ 5 ]),
  TENNIS: populate([ 8 ]),
  TREADMILL: populate([ 53, 97 ]),
  WEIGHT_TRAINING: populate([ 4, 50 ]),
  YOGA: populate([ 95 ]),
};

/**
 * Converts input sport to SHG-compatible sport
 * @param {String} [sport='Workout'] Sport to convert
 * @returns {String} Corresponding sport
 */
function convertSport(sport = 'Workout') {
  sport = (sport)
    // eslint-disable-next-line newline-per-chained-call
    ? (sport.trim().charAt(0).toUpperCase()) + (sport.trim().slice(1).toLowerCase())
    : 'Workout';

  let finalSport = 'Workout';

  if (validValues.includes(sport)) {
    finalSport = sport;
  } else {

    Object.keys(supportedSports).some(key => {
      if (supportedSports[key].includes(sport)) {
        finalSport = SHG_SPORTS[key];

        return true;
      }

      return false;
    });
  }

  return finalSport;
}

module.exports = convertSport;
